import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  amountDue() {
    return faker.number.int();
  },

  creditsApplied() {
    return faker.number.int();
  },

  total() {
    return faker.number.int();
  },

  discountAmount() {
    return faker.number.int();
  },
  period() {
    return faker.helpers.arrayElement(['monthly', 'yearly']);
  },
});
